module.exports = __webpack_public_path__ + "static/media/welcome-partying-face.fa2fc26d.svg";